import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import auth from './modules/auth'
import motions from './modules/motions'
import sessions from './modules/sessions'
import delegates from './modules/delegates'
import jobs from './modules/jobs'
import screens from './modules/screen'
import cards from './modules/cards'
import screenshots from './modules/screenshots'
import settings from './modules/settings'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth', 'sessions', 'jobs']
})
/**
const sessionsStorage = new VuexPersistence({
  storage: window.localStorage,
  modules: ['sessions'],
  reducer: (state) => ({all: state.all})
})
**/
Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  plugins: [vuexLocal.plugin],
  modules: {
    auth,
    sessions,
    motions,
    delegates,
    jobs,
    screens,
    cards,
    screenshots,
    settings
  },
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js